// src/pages/About.js

import React from 'react';
import './About.css'; 

import JungleBackground from '../components/JungleBackground';
import Footer from '../components/Footer';

// Import all the other page assets
import forestImage from '../assets/about-page/forest-image.jpg';
import waterDropletsImage from '../assets/about-page/water-droplets.jpg';
import teamMember1 from '../assets/about-page/team-member-1.jpg';
import teamMember2 from '../assets/about-page/team-member-2.jpg';
import teamMember3 from '../assets/about-page/team-member-3.jpg';
import sustainabilityIcon from '../assets/about-page/icon-sustainability.png';
import clarityIcon from '../assets/about-page/icon-clarity.png';
import growthIcon from '../assets/about-page/icon-growth.png';
import collaborationIcon from '../assets/about-page/icon-collaboration.png';

const About = () => {
  return (
    <div className="about-page-container">
      <JungleBackground />
      
      <section className="about-section mission-section">
        <h1>About Govindam</h1>
        <p>
          Our mission is to harmonize modern digital solutions with the wisdom of timeless
          traditions, fostering growth and sustainability. We believe in innovative technologies
          that respect and learn from the natural world.
        </p>
      </section>

      <section className="about-section image-gallery">
        <img src={forestImage} alt="Sunlight filtering through a lush green forest" />
        <img src={waterDropletsImage} alt="Close-up of water droplets on a plant leaf" />
      </section>

      {/* --- This wrapper creates the two-column layout --- */}
      <div className="team-values-wrapper">
        <section className="about-section team-section">
          <h2>Our Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <img src={teamMember1} alt="Team member Dhruv Achor" className="team-photo" />
              <h3>Dhruv</h3><p>Leader</p>
            </div>
            <div className="team-member">
              <img src={teamMember2} alt="Team member Ricky" className="team-photo" />
              <h3>Ricky</h3><p>The Beast</p>
            </div>
            <div className="team-member">
              <img src={teamMember3} alt="Team member Poorv Achor" className="team-photo" />
              <h3>Poorv</h3><p> Developer </p>
            </div>
          </div>
        </section>

        <section className="about-section values-section">
          <h2>Core Values</h2>
          <div className="values-grid">
            <div className="value-item"><img src={sustainabilityIcon} alt="Sustainability" /><span>Sustainability</span></div>
            <div className="value-item"><img src={clarityIcon} alt="Clarity" /><span>Clarity</span></div>
            <div className="value-item"><img src={growthIcon} alt="Growth" /><span>Growth</span></div>
            <div className="value-item"><img src={collaborationIcon} alt="Collaboration" /><span>Collaboration</span></div>
          </div>
        </section>
      </div>

      <section className="about-section cta-section">
        <h2>Call to Action</h2>
        <div className="cta-buttons">
          <a href="#newsletter" className="cta-button">Join Our Newsletter</a>
          <a href="#social" className="cta-button">Follow Us on Social Media</a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;